export const UserToUpdate = Object.freeze({
    FIRST: 'userFirst',
    SECOND: 'userSecond',
    BOTH: 'both'
});
export const Steps = Object.freeze({
    ADVISOR: 'advisor',
    USER_INFO: 'userInfo',
    MARITAL_STATUS_AND_BOOKING: 'maritalStatusAndBooking',
    CONSENT: 'consent',
    ADD_DOCUMENTS: 'addDocuments',
    ADVANCED: 'advanced',
    END: 'end'
});
export const MeetingTypes = Object.freeze({
    PHONE: 'phone',
    FACE_TO_FACE: 'face_to_face'
});
export const MaritalTypes = Object.freeze({
    MARITAL_SINGLE: 'single',
    MARITAL_RELATIONSHIP: 'partnersNotMarried',
    MARITAL_MARRIED: 'married'
});
export const AssetTypes = ['property', 'saving', 'pension', 'value'];
export const UserFields = Object.freeze({
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    PHONE: 'phone',
    ENABLED_DOCUMENTS_AND_TIME_BOOKING: 'enabledDocumentsAndTimeBooking',
    DOCUMENTS: 'documents',
    CONSENTS: 'consents',
    CONSENT_IDS: 'consentIds',
    COMMENT: 'comment',
    PARTNER_PRESENT: 'partner_present',
    PRIMARY_CONTACT: 'primaryContact',
    MEETING_TYPE: 'meeting_medium',
    SHARING_SCREEN: 'sharing_screen',
    ADVISOR_ID: 'advisorId',
    BRANCH_ID: 'branchId',
    MARITAL: 'maritalStatus',
    ASSETS: 'assets',
    CHILDREN: 'hasChildren',
    CHILDREN_OUTSIDE_RELATIONSHIP: 'hasChildrenOutsideRelationship',
    MARRIAGE: 'marriagePlanned',
    RESIDENCE: 'livingTogether',
    IS_ADVISOR: 'isAdvisor',
    IS_REAL_ESTATE_PLANNED: 'is_real_estate_purchase_planned',
    REAL_ESTATE_PURCHASE_TYPE: 'real_estate_purchase_type'
});
export const AdditionalFields = Object.freeze({
    PRODUCTS: 'products',
    BOOKING: 'booking'
});
export const RealEstatePurchaseTypes = ['share', 'owner', 'enterprise', 'parental', 'holiday', 'leisure', 'country', 'villa'];
export const ScrollDelayTimeoutMs = 100;
